import './menu.css';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';

const Menu = () => {
  return (
    <div>
      <div id='mainsection'>
        <div className="order">
          <h2>Faça uma encomenda agora!</h2>
          <h3><i><WhatsAppIcon id='wppicon'/> </i>21 98077 3683</h3>
          <h3> <i><InstagramIcon id='insticon' /> </i>@casagourmetds</h3>
        </div>
        <section id="menu-list" className="section-padding">
        <div className="container">
          <div className="row">
            </div>
            <div className="check">
              check
            </div>
            <div className="deliveryContainer1">
              <h4>Fazemos entrega! <i><DeliveryDiningIcon /></i></h4>
              <p>(Consulte o valor de frete)</p>
            </div>
            <div className="foodContainer1">
              <h4>Pacotes pré assados</h4>
            </div>
            <hr/>
            <hr/>
            <div className="foodContainer">
              <h4>25 Mini Pizzas Salgada</h4>
              <p>Presunto c/ Queijo, Calabresa, Frango c/ Catupiry</p>
              <em>R$ 19.90</em>
            </div>
            <hr  id='hr' />

            <div className="foodContainer">
              <h4>25 Mini Pizzas Doce</h4>
              <p>Chocolate, Banana ou Romeu e Julieta</p>
              <em>R$ 21.90</em>
            </div>
            <hr  id='hr' />

            <div className="foodContainer">
              <h4>50 Mini Pizzas Salgadas</h4>
              <p>Presunto c/ Queijo, Calabresa, Frango c/ Catupiry </p>
              <em>R$ 34.90</em>
            </div>
            <hr/>


            <hr />
            <div className="foodContainer">
              <h4>50 Mini Pizzas Doces</h4>
              <p>Chocolate, Banana ou Romeu e Julieta</p>
              <em>R$ 39.90</em>
            </div>
            <hr  id='hr' />

            
            <hr  id='hr' />
            <div className="foodContainer">
              <h4>25 Mini Pizzas Salgada + 25 Doce</h4>
              <p>Presunto c/ Queijo, Calabresa, Frango c/ Catupiry</p>
              <p>Chocolate, Banana ou Romeu e Julieta</p>
              <em>R$ 39.90</em>
            </div>
            <hr/>

            <hr  id='hr' />
            <div className="foodContainer">
              <h4>300 Mini Pizzas + 50 Mini Pizzas Gratis</h4>
              <p>Presunto c/ Queijo, Calabresa, Frango c/ Catupiry</p>
              <p>Chocolate, Banana ou Romeu e Julieta</p>
              <em>R$ 209.90</em>
            </div>
          </div>
      </section>
    </div>

    </div>
  )
}

export default Menu;